import {ValueObject} from '@s-ui/domain'

import {AddComparatorAdsError} from '../Errors/AddComparatorAdsError.js'
import {ComparatorAdAdsValueObject} from './ComparatorAdAdsValueObject.js'

export class ComparatorListAdsValueObject extends ValueObject {
  #ads

  static MAX_ADS = 3

  constructor({ads}) {
    super()
    this.#ads = ads
  }

  static empty() {
    return new ComparatorListAdsValueObject({ads: []})
  }

  static create({ads}) {
    if (!Array.isArray(ads)) return ComparatorListAdsValueObject.empty()
    return new ComparatorListAdsValueObject({ads: ads.map(ad => ComparatorAdAdsValueObject.create(ad))})
  }

  static createFromString({ads}) {
    if (!ads) return ComparatorListAdsValueObject.empty()
    try {
      const validAds = JSON.parse(ads).filter(ComparatorAdAdsValueObject.isValid)
      return ComparatorListAdsValueObject.create({ads: validAds})
    } catch (error) {
      return ComparatorListAdsValueObject.empty()
    }
  }

  get ads() {
    return this.#ads.map(ad => ad.value)
  }

  get value() {
    return {ads: this.ads}
  }

  count() {
    return this.ads.length
  }

  hasLimitReached() {
    return this.count() >= ComparatorListAdsValueObject.MAX_ADS
  }

  isExisting({adId}) {
    return this.ads.some(existingAd => Number(existingAd.id) === Number(adId))
  }

  add({ad}) {
    ComparatorAdAdsValueObject.validate(ad)
    if (this.isExisting({adId: ad.id})) return this
    if (this.hasLimitReached()) throw AddComparatorAdsError.createMaxAdsLimitReached()
    return ComparatorListAdsValueObject.create({ads: [...this.ads, ad]})
  }

  remove({adId}) {
    return ComparatorListAdsValueObject.create({
      ads: this.ads.filter(existingAd => Number(existingAd.id) !== Number(adId))
    })
  }

  toJSON() {
    return {ads: this.#ads.map(ad => ad.toJSON())}
  }
}
